import { useEffect, useMemo, useState } from "react";
import { api, inr } from "@/lib/api";
import { PageHeader } from "@/components/app/UI";

export default function VendorPerformance() {
  const [rows, setRows] = useState([]);
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/purchasing/vendor-performance"), api.get("/purchasing/vendors")])
      .then(([v, vs]) => { setRows(v.data); setVendors(vs.data); });
  }, []);

  const vendorName = useMemo(() => Object.fromEntries(vendors.map((v) => [v.id, v.name])), [vendors]);
  const vendorObj = useMemo(() => Object.fromEntries(vendors.map((v) => [v.id, v])), [vendors]);

  return (
    <div data-testid="pv-vp-page">
      <PageHeader eyebrow="Purchasing" title="Vendor Performance" subtitle="Delivery reliability, volume, on-time %, and a composite score to guide sourcing decisions." />
      <div className="p-4 sm:p-8">
        <div className="border border-[#E5E7EB] overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F9FAFB] border-b border-[#E5E7EB]">
              <tr>{["Vendor", "GST", "Total POs", "Delivered", "Pending", "Delayed", "On-time %", "Avg Days", "Total Value", "Score"].map((h, i) => (
                <th key={i} className="text-left label-eyebrow !text-[10px] px-4 py-3">{h}</th>
              ))}</tr>
            </thead>
            <tbody>
              {rows.map((v) => {
                const meta = vendorObj[v.vendor_id] || {};
                return (
                  <tr key={v.vendor_id} className="border-b border-[#F3F4F6] hover:bg-[#F9FAFB]" data-testid={`pv-vp-full-row-${v.vendor_id}`}>
                    <td className="px-4 py-3 text-xs font-semibold">
                      {vendorName[v.vendor_id] || "—"}
                      {meta.preferred && <span className="ml-2 text-[9px] text-[#D97706] font-bold uppercase tracking-widest">Preferred</span>}
                    </td>
                    <td className="px-4 py-3 text-xs font-mono">{meta.gst_number || "—"}</td>
                    <td className="px-4 py-3 text-xs">{v.total_pos}</td>
                    <td className="px-4 py-3 text-xs">{v.delivered_pos}</td>
                    <td className="px-4 py-3 text-xs">{v.pending_pos}</td>
                    <td className={`px-4 py-3 text-xs ${v.delayed_pos ? "text-[#DC2626] font-bold" : ""}`}>{v.delayed_pos}</td>
                    <td className="px-4 py-3 text-xs">{v.on_time_pct != null ? `${v.on_time_pct}%` : "—"}</td>
                    <td className="px-4 py-3 text-xs">{v.avg_delivery_days != null ? `${v.avg_delivery_days} d` : "—"}</td>
                    <td className="px-4 py-3 text-xs font-mono">{inr(v.total_value)}</td>
                    <td className="px-4 py-3 text-sm font-bold" style={{ color: v.score >= 75 ? "#059669" : v.score >= 50 ? "#D97706" : "#DC2626" }}>{v.score}</td>
                  </tr>
                );
              })}
              {rows.length === 0 && <tr><td colSpan={10} className="text-center text-sm text-[#9CA3AF] py-12">No vendor data yet. Performance metrics build up as POs are placed and GRNs recorded.</td></tr>}
            </tbody>
          </table>
        </div>
        <div className="text-[10px] text-[#9CA3AF] mt-3">Score weighting: on-time % (60%) + PO volume (up to 40 pts) − avg delivery days penalty. Range 0-100.</div>
      </div>
    </div>
  );
}
